<template>
	<v-row no-gutters>
		<v-col class="pb-0" cols="12">
			<v-expansion-panels accordion :multiple="false" flat :elevation="1">
				<v-expansion-panel :elevation="0">
					<v-expansion-panel-header :elevation="0" color="#f6f6f6" class="font-weight-bold ma-0 pa-2">Search & Query Tools</v-expansion-panel-header>
					<v-expansion-panel-content color="#f6f6f6" class="lb-dashboard-expansion-panel-content pa-2" justify="center" align="center">
						<v-card class="mb-3 pa-2" elevation="0">
							<v-row>
								<v-col>
									<v-btn block depressed @click="GotoLocumSearchTool">Locum Search Tool</v-btn>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-btn block depressed @click="GotoPracticeSearchTool">Practice Search Tool</v-btn>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<v-btn block depressed @click="goToBookingsSearch">Bookings Search</v-btn>
								</v-col>
							</v-row>
						</v-card>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</v-col>
	</v-row>
</template>

<script>
import { bus } from '@/main';
import store from '@/store';

export default {
	name: 'PracticeDashboardLandingZone',
	components: {},
	data: () => ({}),
	computed: {
		call_for_actions() {
			return store.getters.getNotifications;
		},
	},
	mounted() {
		bus.$on('call-for-action', calledforaction => {
			if (!('component' in calledforaction) || !('data' in calledforaction)) {
				console.error("called for action with bad payload. Expected [string] 'component'. [Object] 'data' . Got :", calledforaction);
			} else {
				this.call_for_actions.push(calledforaction);
			}
		});
	},
	methods: {
		dismissNotification() {
			store.commit('POP_NOTIFICATION');
		},
		derp() {
			store.commit('PUSH_NOTIFICATION', { component: 'practice-offer-set', data: ['derpderp'] });
		},
		GotoLocumSearchTool() {
			// make sure to reset the last search
			const currentPage = store.getters.currentRoute;
			if (currentPage == '/admin/dashboard/practicetool') store.commit('SET_ADMIN_LAST_SEARCH', false);

			store.commit('SET_CURRENT_ROUTE', '/admin/dashboard/locumtool');
			bus.$emit('change-main-context', 'LocumSearchTool');
		},
		GotoPracticeSearchTool() {
			// make sure to reset the last search
			const currentPage = store.getters.currentRoute;
			if (currentPage == '/admin/dashboard/locumtool') store.commit('SET_ADMIN_LAST_SEARCH', false);

			store.commit('SET_CURRENT_ROUTE', '/admin/dashboard/practicetool');
			bus.$emit('change-main-context', 'PracticeSearchTool');
		},
		goToBookingsSearch() {
			this.$router.push({ name: 'AdminBookingSearch' });
		},
	},
};
</script>
